// import CharCount from "char-count-es6/src/CharCount";

export const formHelpers = {
	init: () => {
		initFormNoSubmit();
		initFieldsCharLimit();
	},
};

function initFormNoSubmit() {
	const noSubmitForms = document.querySelectorAll( 'form.no-submit' );
	noSubmitForms.forEach( ( form ) => {
		form.addEventListener( 'submit', ( e ) => {
			e.preventDefault();
			return false;
		} );
	} );
}

function initFieldsCharLimit() {
	// const limitedFields = document.querySelectorAll( '.with-char-counter[maxlength]' );
	// limitedFields.forEach( ( field ) => {
	// 	new CharCount( {
	// 		selector: field,
	// 		expendedThreshold: field.maxlength,
	// 	} );
	// } );
}
